export default __webpack_public_path__ + "static/media/1.88ad371c.png";